const EXCEPTIONS = {
  swms: 'SWMS',
  itps: 'ITPs',
  sds: 'SDS',
  ai: 'AI',
}

const appostropheWords = {
  cant: "can't",
  wont: "won't",
}

const fixAppostrophe = (string: string): string => {
  if (!string) return string

  if (appostropheWords[string.toLowerCase()]) {
    return appostropheWords[string.toLowerCase()]
  }
  return string
}

/**
 * Converting uppercase enum to title case
 * e.g. IN_PROGRESS -> In Progress
 * @param {String} enumString - object key target
 * @param {Boolean} capitaliseEachWord - whether only the first word should be capitalised
 * @return {String} Title case version of enum
 */
const convertEnumToString = (
  enumString: string,
  capitaliseEachWord = true
): string => {
  if (!enumString) return enumString

  const titleCase = enumString
    .split('_')
    .map(fixAppostrophe)
    .map((w, index) => {
      if (EXCEPTIONS[w.toLowerCase()]) {
        return EXCEPTIONS[w.toLowerCase()]
      }

      if (capitaliseEachWord || index === 0) {
        return w[0].toUpperCase() + w.substring(1).toLowerCase()
      } else {
        return w.toLowerCase()
      }
    })
    .join(' ')

  return titleCase
}

export default convertEnumToString
